<div class="app-kinds">
  @for (appKind of appKinds; track appKind.url) {
    <rt-button
      [variant]="appKind.active ? 'primary' : 'outline'"
      (click)="selectAppKind(appKind.url)"
      >{{ appKind.label }}</rt-button
    >
  }
</div>

<pre id="debug">{{ debug() | json }}</pre>
